'use client';

import Link from 'next/link';
import type React from 'react';

import { cn } from '@/lib/utils';
import type { NavItem } from '@/types/nav';

export function Nav({
  items,
  activeId,
  className,
}: {
  items: NavItem[];
  activeId?: string;
  className?: string;
}) {
  return (
    <nav
      aria-label="Main"
      data-active-id={activeId}
      className={cn('flex items-center gap-4', className)}
    >
      {items.map(({ title, href }) => {
        const active =
          activeId === href ||
          (href === '/' // Home page
            ? ['/', '/index'].includes(activeId || '')
            : activeId?.startsWith(href));

        return (
          <NavItemLink key={href} href={href} active={active}>
            {title}
          </NavItemLink>
        );
      })}
    </nav>
  );
}

export function NavItemLink({
  active,
  ...props
}: React.ComponentProps<typeof Link> & {
  active?: boolean;
}) {
  return (
    <Link
      aria-current={active ? 'page' : undefined}
      className={cn(
        'font-mono text-sm font-medium text-muted-foreground transition-[color] duration-300',
        active && 'text-foreground underline underline-offset-4'
      )}
      {...props}
    />
  );
}
